import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue'

export function useFullscreen(target: Ref<HTMLElement | undefined>) {
  const isFullscreen = ref(false)

  function sync() {
    isFullscreen.value = !!target.value && document.fullscreenElement === target.value
  }

  function toggle() {
    if (document.fullscreenElement) void document.exitFullscreen()
    else void target.value?.requestFullscreen()
  }

  onMounted(() => document.addEventListener('fullscreenchange', sync))
  onBeforeUnmount(() => document.removeEventListener('fullscreenchange', sync))

  return { isFullscreen, toggle }
}
